import { HOME_URI } from '../helpers/strings.ts';

export const ENTRY_ROUTE = '/api/entry/';

export const ENTRY_URI_MAX_LENGTH = 2000;

const SEGMENT = '[A-Za-z0-9][A-Za-z0-9_.~-]*';

export const ENTRY_URI_PATTERN = new RegExp(`^(?:${HOME_URI}|${SEGMENT}(?:/${SEGMENT})*)$`);

export const parseEntryUri = (searchParams) => {
  const values = searchParams.getAll('uri');

  if (values.length !== 1 || [...searchParams.keys()].length !== 1) return null;

  const [uri] = values;

  return uri.length <= ENTRY_URI_MAX_LENGTH && ENTRY_URI_PATTERN.test(uri) ? uri : null;
};

export const toEntryUri = (uri) => {
  const segments = (Array.isArray(uri) ? uri : [uri]).flatMap((part) =>
    String(part ?? '')
      .split('/')
      .filter(Boolean)
  );

  return segments.length ? segments.join('/') : HOME_URI;
};
